'use client'

import { useCallback, useEffect, useRef } from 'react'

import { SUPPRESS_OUTSIDE_AFTER_OPEN_MS } from '../share-feedback.const'

export function useSuppressInitialOutsideInteraction(open: boolean) {
  const justOpenedRef = useRef(false)

  useEffect(() => {
    if (!open) return
    justOpenedRef.current = true
    const timer = setTimeout(() => {
      justOpenedRef.current = false
    }, SUPPRESS_OUTSIDE_AFTER_OPEN_MS)
    return () => clearTimeout(timer)
  }, [open])

  const handleInteractOutside = useCallback((event: Event) => {
    if (justOpenedRef.current) {
      event.preventDefault()
      return
    }
    const target = event.target as HTMLElement | null
    if (!target) return
    if (
      target.closest(
        '[data-share-feedback-anchor], [data-help-invoker], [role="menu"], [role="menuitem"], [data-radix-menu-content], [data-radix-popper-content-wrapper]'
      )
    ) {
      event.preventDefault()
    }
  }, [])

  return { handleInteractOutside }
}
